import React, { useEffect } from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import PRIVACY_POLICY_HTML from '../data/privacyPolicyContent';

const PrivacyPolicyPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <main>
        <section className="pt-32 pb-12 bg-gradient-to-br from-white via-secondary/30 to-accent-blue/5">
          <div className="max-w-4xl mx-auto px-6 lg:px-8">
            <h1 className="text-4xl md:text-5xl font-bold text-primary mb-4 leading-tight">
              MUSEIQ Privacy Policy
            </h1>
          </div>
        </section>

        <section className="py-12">
          <div className="max-w-4xl mx-auto px-6 lg:px-8">
            <article
              className="privacy-policy-content prose prose-lg max-w-none"
              dangerouslySetInnerHTML={{ __html: PRIVACY_POLICY_HTML }}
            />
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;
